import React from 'react'
import { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { connect } from 'react-redux'
import Preloader from '../../../Components/Common/Preloader/Preloader'
import CustomButton from '../../../Components/UI/CustomButton/CustomButton'
import Input from '../../../Components/UI/Form/Input'
import Modal from '../../../Components/UI/Modal/Modal'
import Text from '../../../Components/UI/Text/Text/Text'
import { login, me } from '../../../Redux/userReducer'
import { setServerError } from '../../../Redux/commonReducer'
import classes from './Login.module.css'
import { useNavigate } from 'react-router-dom'

const Login = (props) => {
    const { login, isFetching, serverError, setServerError, isAuth, me } = props

    const navigate = useNavigate()

    const { handleSubmit, control } = useForm()

    const onSubmit = (data) => {
        login(data.email, data.password)
    }

    useEffect(() => {
        if(isAuth) {
            navigate('/')
        }
    }, [isAuth])

    useEffect(() => {
        me()
        return () => setServerError(null)
    }, [])

    return (
        <Modal title="Авторизація" className={classes.container}>
            {isFetching && <Preloader/>}
            <form onSubmit={handleSubmit(onSubmit)} className={classes.main}>
                <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Обов'язкове поле!" }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Input
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Username"  
                        />
                    )}
                />
                <Controller
                    name="password"
                    control={control}
                    defaultValue=""
                    rules={{ required: "Обов'язкове поле!" }}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Input
                            onChange={onChange}
                            value={value}
                            error={error}
                            label="Password" 
                            type="password" 
                        />
                    )}
                />
                <CustomButton className={classes.submit} type="submit">Відправити</CustomButton>
                {serverError && <Text variant="error">{serverError}</Text>}
            </form>
        </Modal>
    )
}

let mapStateToProps = (state) => ({
    isFetching: state.common.isFetching,
    serverError: state.common.serverError,
    isAuth: state.user.isAuth
})

export default connect(mapStateToProps, {
    login,
    setServerError,
    me
})(Login)